import L, { CRS } from "leaflet";
import "../../utils/utilsGeo";
import { useEffect, useRef, useState } from "react";
import { MapContainer, TileLayer, useMap } from "react-leaflet";
import { BASE_URL, BASE_URL_GEO } from "../../services/common";

export const MapaGraticule = ({ codigoImovel, bbox }) => {
  console.warn("[MapaGraticule] render", {
    codigoImovel,
    hasBbox: Array.isArray(bbox),
  });
  const [map, setMap] = useState(null);
  const graticuleRef = useRef(null);
  const [layerCity, setLayerCity] = useState(null);
  const lastBboxRef = useRef(null);

  const MapReady = ({ onReady }) => {
    const mapInstance = useMap();
    useEffect(() => {
      if (!mapInstance) return;
      onReady(mapInstance);
    }, [mapInstance, onReady]);
    return null;
  };

  useEffect(() => {
    // endpoint /geoserver/lair/wms espera o layer sem prefixo
    setLayerCity(buildBaseLayer("municipio"));
  }, []);

  useEffect(() => {
    if (map && layerCity) {
      layerCity.addTo(map);
    }
  }, [map, layerCity]);

  useEffect(() => {
    if (!map || !codigoImovel) return;
    carregarLayerImovel();
  }, [map, codigoImovel]);

  const isValidBbox = (value) =>
    Array.isArray(value) &&
    value.length === 2 &&
    value.every(
      (point) =>
        Array.isArray(point) &&
        point.length === 2 &&
        point.every((coord) => Number.isFinite(coord))
    );

  const renderGraticule = () => {
    if (!map) return;
    if (typeof L.latlngGraticule !== "function") {
      console.warn("[MapaGraticule] latlngGraticule nao encontrado em L.");
      return;
    }
    if (graticuleRef.current) {
      try {
        map.removeLayer(graticuleRef.current);
      } catch (err) {
        console.warn("[MapaGraticule] Falha ao remover graticule antigo:", err);
      }
      graticuleRef.current = null;
    }

    const graticule = L.latlngGraticule({
      showLabel: true,
      zoomInterval: [
        { start: 2, end: 3, interval: 30 },
        { start: 4, end: 4, interval: 10 },
        { start: 5, end: 7, interval: 5 },
        { start: 8, end: 9, interval: 0.5 },
        { start: 10, end: 11, interval: 0.1 },
        { start: 12, end: 40, interval: 0.05 },
      ],
      weight: 0.8,
      opacity: 1,
      color: "#111",
      font: "10px Arial",
      fontColor: "#111",
    });

    setTimeout(() => {
      graticule.addTo(map);
      graticuleRef.current = graticule;
      console.warn("[MapaGraticule] graticule renderizado");
    }, 0);
  };

  useEffect(() => {
    if (!map || !bbox) return;
    if (lastBboxRef.current === JSON.stringify(bbox)) return;
    if (!isValidBbox(bbox)) {
      console.warn("[MapaGraticule] bbox invalido, ignorando fitBounds:", bbox);
      return;
    }
    lastBboxRef.current = JSON.stringify(bbox);
    map.invalidateSize(true);
    map.fitBounds(bbox);
    renderGraticule();
    console.warn("[MapaGraticule] zoom:", map.getZoom(), "bbox:", bbox);
  }, [map, bbox]);

  useEffect(() => {
    if (!map) return;
    const container = map.getContainer?.();
    if (container) {
      container.style.background = "transparent";
    }
  }, [map]);

  const carregarLayerImovel = () => {
    // endpoint /geoserver/lair/wms espera o layer sem prefixo
    const lairArea = buildLayerImovel("imovel_area_imovel");
    lairArea?.addTo(map);
  };

  const buildLayerImovel = (layer) => {
    return L.tileLayer.wms(`${BASE_URL_GEO}/geoserver/lair/wms`, {
      layers: layer,
      format: "image/png",
      transparent: true,
      version: "1.1.0",
      styles: "imovel_destaque",
      crs: CRS.EPSG4326,
      srs: "EPSG:4326",
      cql_filter: `cod_imovel='${codigoImovel}'`,
    });
  };

  const buildBaseLayer = (layer) => {
    return L.tileLayer.wms(`${BASE_URL_GEO}/geoserver/lair/wms`, {
      layers: layer,
      format: "image/png",
      transparent: true,
      version: "1.1.0",
      styles: "municipio",
      crs: CRS.EPSG4326,
      srs: "EPSG:4326",
    });
  };

  return (
    <div
      style={{
        position: "relative",
        overflow: "hidden",
        width: "100%",
        height: "100%",
      }}
    >
      <MapContainer
        dragging={false}
        zoomControl={false}
        touchZoom={false}
        scrollWheelZoom={false}
        doubleClickZoom={false}
        boxZoom={false}
        keyboard={false}
        tap={false}
        zoom={8}
        crs={CRS.EPSG4326}
        attributionControl={false}
        center={[-15.793889, -53.882778]}
        className="mapa-graticule"
        style={{
          height: "100%",
          width: "100%",
          pointerEvents: "none",
          background: "transparent",
        }}
      >
        {/* <TileLayer url="https://server.arcgisonline.com/ArcGIS/rest/services/World_Imagery/MapServer/tile/{z}/{y}/{x}" /> */}
        <MapReady
          onReady={(instance) => {
            setMap(instance);
            console.warn("[MapaGraticule] map criado");
          }}
        />
      </MapContainer>
    </div>
  );
};
